import { ToggleGroup, ToggleGroupItem } from "@/src/components/ui/toggle-group"
import { cn } from "@/src/utils/tailwind-cn"

export enum PrecisionType {
  minute = "minute",
  fiveMinutes = "5minutes",
  hour = "hour",
  fourHours = "4hours",
  day = "day",
  week = "week",
  month = "month",
}

const precisionItems = [
  {
    label: "D",
    value: PrecisionType.day,
  },
  {
    label: "W",
    value: PrecisionType.week,
  },
  {
    label: "M",
    value: PrecisionType.month,
  },
]

export function DatePrecisionSelector({
  precision,
  setPrecision,
  className,
}: {
  precision: PrecisionType
  setPrecision: (value: PrecisionType) => void
  className?: string
}) {
  return (
    <ToggleGroup
      type="single"
      value={precision}
      onValueChange={(value) => {
        if (value) setPrecision(value as PrecisionType)
      }}
      className={cn("hidden-on-print flex rounded-3xs bg-muted p-1", className)}>
      {precisionItems.map((item) => (
        <ToggleGroupItem
          key={item.label}
          value={item.value}
          className="h-2 rounded-3xs px-1 text-xs transition-colors data-[state=on]:bg-background sm:h-7 sm:px-2 sm:text-sm">
          {item.label}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  )
}
